export enum CloudVendor {
  GCP = 'GCP',
  AWS = 'AWS',
  AZURE = 'AZURE',
}